/* eslint-disable no-param-reassign,no-prototype-builtins,no-restricted-syntax */
import { def, isArr, isObj } from 'lib/util/index'

/**
 * Checks whether `object` doesn't have any property of its own.
 *
 * @param {Object} object the object to check
 * @returns {boolean}     `true` if `object` doesn't have any property
 */
export const empty = (object) => {
  for (const property in object) {
    if (object.hasOwnProperty(property)) {
      return false
    }
  }
  return true
}

/**
 * Get either the `key` or `value` at a given `index` from an object.
 *
 * @param {Boolean} [key=true]  Whether to return the key or the value of the object
 *
 * @returns {(function(*, number=): (*|null))|*}
 */
const getProperty = (key = true) => (object, index = 0) => {
  if (object !== null && isObj(object) && !empty(object)) {
    return key
      ? Object.keys(object)?.[index] || null
      : Object.values(object)?.[index] || null
  }

  return null
}

/**
 * Get the name of the property at a given `index` from an `object`.
 *
 * @type {(function(*, number=): (*|null))|*}
 */
export const getPropertyName = getProperty(true)

/**
 * Get the value of the property at a given `index` from an `object`.
 *
 * @type {(function(*, number=): (*|null))|*}
 */
export const getPropertyValue = getProperty(false)

/**
 * Returns a copy of `object` in which all property Symbols (recursively) are replaced with normal
 * properties, whose name is the description of the Symbol in uppercase form.
 *
 * @param {Object} object the object to simplify
 * @returns {{}|*}         a copy of `object` with all symbols converted to normal properties
 * @deprecated use web's structuredClone or polyfills instead
 */
export const clone = (object) => {
  if (object !== null) {
    if (isObj(object)) {
      const result = {}
      Object.getOwnPropertyNames(object).reduce((obj, name) => {
        obj[name] = clone(object[name])
        return obj
      }, result)
      Object.getOwnPropertySymbols(object).reduce((obj, symbol) => {
        obj[symbol.description.toUpperCase()] = clone(object[symbol])
        return obj
      }, result)
      return result
    }
    if (isArr(object)) {
      return object.map(clone)
    }
  }
  return object
}
